import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as search from '@webapp/sdk/search';
import SimpleArtist from '@common/types/artist/simple-artist';
import { Actions } from '../../actions';
import { SearchArtists, SearchArtistsSuccess, SearchArtistsError } from '../action-creators';
import { SEARCH_ARTISTS } from '../actions';


export const searchArtistsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SearchArtists>(SEARCH_ARTISTS),
    mergeMap(async (action) => {
      try {
        const response = await search.artists(action.query);

        const artistsList: SimpleArtist[] = response.hits.hits.map((r: any) => r._source);
        
        return new SearchArtistsSuccess(artistsList);
      } catch (err) {
        return new SearchArtistsError(err.message)
      }
    })
  );